import type { ReactNode } from 'react';
import { Container } from '@/components/ui/container';
import { TERMS_VERSION } from '@/lib/legal';
import { useSeo } from '@/lib/seo';

export interface LegalSection {
  h: string;
  body: ReactNode;
}

export function LegalShell({
  title,
  path,
  seoDescription,
  intro,
  sections,
}: {
  title: string;
  /** Route path, for the per-page canonical link (e.g. "/terms"). */
  path: string;
  /** Falls back to `title` if omitted. */
  seoDescription?: string;
  intro: ReactNode;
  sections: LegalSection[];
}) {
  useSeo({ title, description: seoDescription, path });
  return (
    <Container className="max-w-2xl py-14">
      <p className="eyebrow">Legal</p>
      <h1 className="mt-2 text-4xl font-semibold">{title}</h1>
      <p className="mt-3 text-sm text-ink-faint">Version {TERMS_VERSION} · applies worldwide</p>
      <div className="mt-6 text-[0.95rem] leading-relaxed text-ink-soft">{intro}</div>

      <ol className="mt-10 space-y-8">
        {sections.map((s, i) => (
          <li key={s.h}>
            <h2 className="text-lg font-semibold text-ink">
              {i + 1}. {s.h}
            </h2>
            <div className="mt-2 space-y-3 text-[0.95rem] leading-relaxed text-ink-soft">
              {s.body}
            </div>
          </li>
        ))}
      </ol>
    </Container>
  );
}
